module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"signature":{"error":"We were unable to load your email signature."}}}')
  delete Component.options._Ctor
}
